<div class="container-fluid mb-3">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">Scorecard KPIs Setting</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-add button"
      (click)="addNewSetting()">
      Add</div>
  </div>
  <div class="mt-2" style="font-size: 14px;">
    <mat-card>
      <div class="row w-100 m-0" [formGroup]="scoreCardFormGroup">
        <div class="col-md-6 col-lg-4 d-flex flex-column">
          <span>Search</span>
          <mat-form-field appearance="outline" style="width: 90%">
            <input matInput maxlength="100" formControlName="search" [maxlength]="100">
            <mat-hint align="end">{{scoreCardFormGroup.controls.search.value.length || 0}} / 100</mat-hint>
            <!-- <mat-error>{{sectionForm.controls.title.errors?.message}}</mat-error> -->
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 pr-2 col-lg-2">
          <span>Years</span>
          <app-multiple-select
          [data]="years" 
          [defaultAll]="true"
          (result)="filterData($event)"
          [values]="yearSelected"
          ></app-multiple-select>
        </div>
        <div class="col-md-5 px-2 col-lg-4 d-flex align-items-center justify-content-center">
          <button class="btn btn-add btn-outline-primary action-filter" style="height: 43px; margin-top: 12px;"
            (click)="searchData()">Filter</button>
        </div>
      </div>
    </mat-card>
  </div>
  <table mat-table [dataSource]="dataSource" matSort class=" w-100 mt-4" (matSortChange)="sortData($event)">

    <!-- Parent column -->
    <ng-container matColumnDef="parent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header"> Name </th>
      <td mat-cell *matCellDef="let row"> {{row.parent}} </td>
    </ng-container>

    <!-- GSL Number column -->
    <ng-container matColumnDef="gsl">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> GSL Number </th>
      <td mat-cell *matCellDef="let row"> {{row.gsl}} </td>
    </ng-container>

    <!-- Year column -->
    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
      <td mat-cell *matCellDef="let row"> {{row.year}} </td>
    </ng-container>

    <!-- Action column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
      <td mat-cell *matCellDef="let row" style="text-align: center;">
        <div class="d-flex justify-content-center align-items-center">
          <span class="material-icons action" (click)="edit(row.parent, row.year, row.gsl)" style="cursor: pointer;" [matTooltip]="'Edit'">
            edit </span>
          <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
            (click)="deleteSetting(row.parent, row.year, row.gsl)" style="cursor: pointer; font-size:23px"></i>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
    [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
</div>